import UpperSec from "./UpperSec";

export default UpperSec;
